import { PersonLeaveLimitSettingsComponent } from './Component/Person/PersonLeaveLimitSettings/PersonLeaveLimitSettings.component';
import { DataEntityBalanceFormComponent } from './Component/DataEntity/DataEntityBalanceForm/DataEntityBalanceForm.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgxPaginationModule } from 'ngx-pagination';
import { NgPersianDatepickerModule } from 'ng-persian-datepicker';
import { ModalModule,BsModalService } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { PersianDatepickerInputCompatDirective } from './Directive/persian-datepicker-input-compat.directive';
import { CalibrationConfirmInvoiceComponent } from './Component/CalibrationConfirmInvoice/CalibrationConfirmInvoice.component';
import { CalibrationConfirmInvoiceFormComponent } from './Component/CalibrationConfirmInvoice/CalibrationConfirmInvoiceForm.component';
import { LetterrequestcustomerFactor2Component } from './Component/LetterrequestcustomerFactor2/LetterrequestcustomerFactor2.component';
import { LetterrequestcustomerFactor2FormComponent } from './Component/LetterrequestcustomerFactor2/LetterrequestcustomerFactor2Form.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './Component/Nav/Nav.component';
import { CustomerAddComponent } from './Component/Cutomer/CustomerAdd/CustomerAdd.component';
import { CustomerEditComponent } from './Component/Cutomer/CustomerEdit/CustomerEdit.component';
import { CustomerListComponent } from './Component/Cutomer/CustomerList/CustomerList.component';
import { FeildActiviryAddComponent } from './Component/FieldActivity/FeildActiviryAdd/FeildActiviryAdd.component';
import { FeildActivityListComponent } from './Component/FieldActivity/FeildActivityList/FeildActivityList.component';
import { FieldActivityEditComponent } from './Component/FieldActivity/FieldActivityEdit/FieldActivityEdit.component';
import { FilterPipe } from './Pipe/filter.pipe';

import { DeviceListComponent } from './Component/Device/DeviceList/DeviceList.component';
import { DeviceEditComponent } from './Component/Device/DeviceEdit/DeviceEdit.component';
import { DeviceAddComponent } from './Component/Device/DeviceAdd/DeviceAdd.component';
import { UserAddComponent } from './Component/User/UserAdd/UserAdd.component';
import { UserEditComponent } from './Component/User/UserEdit/UserEdit.component';
import { UserListComponent } from './Component/User/UserList/UserList.component';
import { ExpertCalibrationAddComponent } from './Component/ExpertCalibration/ExpertCalibrationAdd/ExpertCalibrationAdd.component';
import { ExpertCalibrationEditComponent } from './Component/ExpertCalibration/ExpertCalibrationEdit/ExpertCalibrationEdit.component';
import { ExpertCalibrationListComponent } from './Component/ExpertCalibration/ExpertCalibrationList/ExpertCalibrationList.component';
import { CalibrationInPositionFormComponent } from './Component/Calibration/CalibrationInPosition/CalibrationInPositionForm/CalibrationInPositionForm.component';
import { CalibrationInPositionListComponent } from './Component/Calibration/CalibrationInPosition/CalibrationInPositionList/CalibrationInPositionList.component';
import { CalibrationReceptionFormComponent } from './Component/Calibration/CalibrationReception/CalibrationReceptionForm/CalibrationReceptionForm.component';
import { CalibrationReceptionListComponent } from './Component/Calibration/CalibrationReception/CalibrationReceptionList/CalibrationReceptionList.component';
import { CertificateFormComponent } from './Component/Certificate/CertificateForm/CertificateForm.component';
import { CertificateListComponent } from './Component/Certificate/CertificateList/CertificateList.component';
import { LabDownloadUploadDeviceComponent } from './Component/Lab/LabDownloadUploadDevice/LabDownloadUploadDevice.component';
import { ExpirationListComponent } from './Component/Expiration/ExpirationList/ExpirationList.component';
import { ExpirationAddComponent } from './Component/Expiration/ExpirationAdd/ExpirationAdd.component';
import { ExpirationEditComponent } from './Component/Expiration/ExpirationEdit/ExpirationEdit.component';
import { LoginComponent } from './Component/Login/Login.component';
import { AuthInterceptor } from './Service/Auth/auth.interceptor';
import { CertifivateDeliveryListComponent } from './Component/Certificate/CertifivateDelivery/CertifivateDeliveryList/CertifivateDeliveryList.component';
import { CertifivateDeliveryFormComponent } from './Component/Certificate/CertifivateDelivery/CertifivateDeliveryForm/CertifivateDeliveryForm.component';
import { SematListComponent } from './Component/Semat/SematList/SematList.component';
import { SematAddComponent } from './Component/Semat/SematAdd/SematAdd.component';
import { SematEditComponent } from './Component/Semat/SematEdit/SematEdit.component';
import { SarFaslAmozeshiListComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiList/SarFaslAmozeshiList.component';
import { SarFaslAmozeshiAddComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiAdd/SarFaslAmozeshiAdd.component';
import { SarFaslAmozeshiEditComponent } from './Component/SarFaslAmozeshi/SarFaslAmozeshiEdit/SarFaslAmozeshiEdit.component';
import { DorehAmoozeshiListComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiList/DorehAmoozeshiList.component';
import { DorehAmoozeshiAddComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiAdd/DorehAmoozeshiAdd.component';
import { DorehAmoozeshiEditComponent } from './Component/DorehAmoozeshi/DorehAmoozeshiEdit/DorehAmoozeshiEdit.component';
import { SkillListComponent } from './Component/Skill/SkillList/SkillList.component';
import { SkillAddComponent } from './Component/Skill/SkillAdd/SkillAdd.component';
import { SkillEditComponent } from './Component/Skill/SkillEdit/SkillEdit.component';
import { DocumentGroupListComponent } from './Component/DocumentGroup/DocumentGroupList/DocumentGroupList.component';
import { DocumentGroupAddComponent } from './Component/DocumentGroup/DocumentGroupAdd/DocumentGroupAdd.component';
import { DocumentGroupEditComponent } from './Component/DocumentGroup/DocumentGroupEdit/DocumentGroupEdit.component';
import { DocumentTitleListComponent } from './Component/DocumentTitle/DocumentTitleList/DocumentTitleList.component';
import { DocumentTitleAddComponent } from './Component/DocumentTitle/DocumentTitleAdd/DocumentTitleAdd.component';
import { DocumentTitleEditComponent } from './Component/DocumentTitle/DocumentTitleEdit/DocumentTitleEdit.component';
import { PersonListComponent } from './Component/Person/PersonList/PersonList.component';
import { PersonAddComponent } from './Component/Person/PersonAdd/PersonAdd.component';
import { PersonEditComponent } from './Component/Person/PersonEdit/PersonEdit.component';
import { CertificateAsliComponent } from './Component/Certificate/CertificateAsli/CertificateAsli.component';
import { SMSTextListComponent } from './Component/SMSText/SMSTextList/SMSTextList.component';
import { SMSTextAddComponent } from './Component/SMSText/SMSTextAdd/SMSTextAdd.component';
import { SMSTextEditComponent } from './Component/SMSText/SMSTextEdit/SMSTextEdit.component';
import { SubjectLetterListComponent } from './Component/SubjectLetter/SubjectLetterList/SubjectLetterList.component';
import { SubjectLetterAddComponent } from './Component/SubjectLetter/SubjectLetterAdd/SubjectLetterAdd.component';
import { SubjectLetterEditComponent } from './Component/SubjectLetter/SubjectLetterEdit/SubjectLetterEdit.component';
import { DeviceGroupComponent } from './Component/DeviceGroup/DeviceGroup.component';
import { MailMessageListComponent } from './Component/MailMessage/MailMessageList/MailMessageList.component';
import { MailMessageAddComponent } from './Component/MailMessage/MailMessageAdd/MailMessageAdd.component';
import { MailMessageEditComponent } from './Component/MailMessage/MailMessageEdit/MailMessageEdit.component';
import { TextletterListComponent } from './Component/Textletter/TextletterList/TextletterList.component';
import { TextletterEditComponent } from './Component/Textletter/TextletterEdit/TextletterEdit.component';
import { TextletterAddComponent } from './Component/Textletter/TextletterAdd/TextletterAdd.component';
import { DeviceBehfaListComponent } from './Component/DeviceBehfa/DeviceBehfaList/DeviceBehfaList.component';
import { DeviceBehfaAddComponent } from './Component/DeviceBehfa/DeviceBehfaAdd/DeviceBehfaAdd.component';
import { DeviceBehfaEditComponent } from './Component/DeviceBehfa/DeviceBehfaEdit/DeviceBehfaEdit.component';
import { UnitListComponent } from './Component/Unit/UnitList/UnitList.component';
import { UnitAddComponent } from './Component/Unit/UnitAdd/UnitAdd.component';
import { UnitEditComponent } from './Component/Unit/UnitEdit/UnitEdit.component';
import { TariffListComponent } from './Component/Tariff/TariffList/TariffList.component';
import { TariffAddComponent } from './Component/Tariff/TariffAdd/TariffAdd.component';
import { TariffEditComponent } from './Component/Tariff/TariffEdit/TariffEdit.component';
import { DeviceBehfaDownloadUploadComponent } from './Component/DeviceBehfa/DeviceBehfaDownloadUpload/DeviceBehfaDownloadUpload.component';
import { DeviceBehfaGozareshKarkardComponent } from './Component/DeviceBehfa/DeviceBehfaGozareshKarkard/DeviceBehfaGozareshKarkard.component';
import { QUANTITYComponent } from './Component/QUANTITY/QUANTITY.component';
import { DeviceBehfaConfirmUploadedComponent } from './Component/DeviceBehfa/DeviceBehfaConfirmUploaded/DeviceBehfaConfirmUploaded.component';
import { DefinitionscertificateListComponent } from './Component/Definitionscertificate/DefinitionscertificateList/DefinitionscertificateList.component';
import { DefinitionscertificateAddComponent } from './Component/Definitionscertificate/DefinitionscertificateAdd/DefinitionscertificateAdd.component';
import { DevicepersianAddComponent } from './Component/Devicepersian/DevicepersianAdd/DevicepersianAdd.component';
import { DevicepersianListComponent } from './Component/Devicepersian/DevicepersianList/DevicepersianList.component';
import { DevicepersianEditComponent } from './Component/Devicepersian/DevicepersianEdit/DevicepersianEdit.component';
import { LetterRequestCustomerComponent } from './Component/Letter/LetterRequestCustomer/LetterRequestCustomer.component';
import { LetterRequestCustomerFormComponent } from './Component/Letter/LetterRequestCustomerForm/LetterRequestCustomerForm.component';
import { DashboardComponent } from './Component/Dashboard/Dashboard.component';
import { LabCalibrationComponent } from './Component/Lab/LabCalibration/LabCalibration.component';
import { DataEntity01Component } from './Component/DataEntity/DataEntity01/DataEntity01.component';
import { LabConfirmCalibrationComponent } from './Component/Lab/LabConfirmCalibration/LabConfirmCalibration.component';
import { LabCertificateComponent } from './Component/Lab/LabCertificate/LabCertificate.component';
import { LetterRequestCustomerDraftFormComponent } from './Component/Letter/LetterRequestCustomerDraftForm/LetterRequestCustomerDraftForm.component';
import { DeviceGroupTreeviewComponent } from './Component/DeviceGroup/DeviceGroupTreeview/DeviceGroupTreeview.component';
import { UserTreeviewComponent } from './Component/User/UserTreeview/UserTreeview.component';
import { LetterRequestCustomerHistoryComponent } from './Component/Letter/LetterRequestCustomerHistory/LetterRequestCustomerHistory.component';
import { LetterRequestCustomerPeyvastComponent } from './Component/Letter/LetterRequestCustomerPeyvast/LetterRequestCustomerPeyvast.component';

import { NgxImgZoomModule } from 'ngx-img-zoom';
import { LetterRequestCustomerPreOrderComponent } from './Component/Letter/LetterRequestCustomerPreOrder/LetterRequestCustomerPreOrder.component';
import { CutomeruserformComponent } from './Component/Cutomer/Cutomeruserform/Cutomeruserform.component';
import { RepresentativeEditComponent } from './Component/Representative/RepresentativeEdit/RepresentativeEdit.component';
import { RepresentativeAddComponent } from './Component/Representative/RepresentativeAdd/RepresentativeAdd.component';
import { RepresentativeListComponent } from './Component/Representative/RepresentativeList/RepresentativeList.component';
import { TicketListComponent } from './Component/Ticket/TicketList/TicketList.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TicketFormComponent } from './Component/Ticket/TicketForm/TicketForm.component';
import { TicketReplyComponent } from './Component/Ticket/TicketReply/TicketReply.component';
import { TicketAdminFormComponent } from './Component/Ticket/TicketAdminForm/TicketAdminForm.component';
import { BehfaRoleAddComponent } from './Component/BehfaRole/BehfaRoleAdd/BehfaRoleAdd.component';
import { BehfaRoleListComponent } from './Component/BehfaRole/BehfaRoleList/BehfaRoleList.component';
import { BehfaRoleEditComponent } from './Component/BehfaRole/BehfaRoleEdit/BehfaRoleEdit.component';
import { BehfaRoleListAdminComponent } from './Component/BehfaRole/BehfaRoleListAdmin/BehfaRoleListAdmin.component';
import { LetterRequestCustomerCalibrationComponent } from './Component/Letter/LetterRequestCustomerCalibration/LetterRequestCustomerCalibration.component';
import { LetterRequestCustomerCalibrationListComponent } from './Component/Letter/LetterRequestCustomerCalibrationList/LetterRequestCustomerCalibrationList.component';
import { BehfaListAdminComponent } from './Component/Behfa/BehfaListAdmin/BehfaListAdmin.component';
import { BehfaListComponent } from './Component/Behfa/BehfaList/BehfaList.component';
import { TicketCategoryAddComponent } from './Component/Ticket/TicketCategory/TicketCategoryAdd/TicketCategoryAdd.component';
import { TicketCategoryEditComponent } from './Component/Ticket/TicketCategory/TicketCategoryEdit/TicketCategoryEdit.component';
import { TicketCategoryListComponent } from './Component/Ticket/TicketCategory/TicketCategoryList/TicketCategoryList.component';
import { LetterRequestCustomerPreOrderListComponent } from './Component/Letter/LetterRequestCustomerPreOrderList/LetterRequestCustomerPreOrderList.component';
import { LetterRequestCustomerDeviceListComponent } from './Component/Letter/LetterRequestCustomerDeviceList/LetterRequestCustomerDeviceList.component';
import { LetterRequestCustomerDeviceComponent } from './Component/Letter/LetterRequestCustomerDevice/LetterRequestCustomerDevice.component';
import { LabDownloadDeviceFormComponent } from './Component/Lab/LabDownloadDeviceForm/LabDownloadDeviceForm.component';
import { LabUploadDeviceFormComponent } from './Component/Lab/LabUploadDeviceForm/LabUploadDeviceForm.component';
import { DeviceBehfaDownloadFormComponent } from './Component/DeviceBehfa/DeviceBehfaDownloadForm/DeviceBehfaDownloadForm.component';
import { DeviceBehfaUploadFormComponent } from './Component/DeviceBehfa/DeviceBehfaUploadForm/DeviceBehfaUploadForm.component';
import { CutomerInfoComponent } from './Component/Cutomer/CutomerInfo/CutomerInfo.component';
import { LockscreenComponent } from './Component/Lockscreen/Lockscreen.component';
import { ContractorListComponent } from './Component/Contractor/ContractorList/ContractorList.component';
import { ContractorAddComponent } from './Component/Contractor/ContractorAdd/ContractorAdd.component';
import { ContractorEditComponent } from './Component/Contractor/ContractorEdit/ContractorEdit.component';
import { ContractorCustomerComponent } from './Component/Contractor/ContractorCustomer/ContractorCustomer.component';
import { CutomerCommentComponent } from './Component/Cutomer/CutomerComment/CutomerComment.component';
import { CutomerCommentViewComponent } from './Component/Cutomer/CutomerCommentView/CutomerCommentView.component';
import { CutomerCommentCheckComponent } from './Component/Cutomer/CutomerCommentCheck/CutomerCommentCheck.component';
import { DeviceBehfaChangeOperationComponent } from './Component/DeviceBehfa/DeviceBehfaChangeOperation/DeviceBehfaChangeOperation.component';
import { AddressTitleListComponent } from './Component/AddressTitle/AddressTitleList/AddressTitleList.component';
import { AddressTitleAddComponent } from './Component/AddressTitle/AddressTitleAdd/AddressTitleAdd.component';
import { AddressTitleEditComponent } from './Component/AddressTitle/AddressTitleEdit/AddressTitleEdit.component';
import { LetterRequestCustomerScheduleComponent } from './Component/Letter/LetterRequestCustomerSchedule/LetterRequestCustomerSchedule.component';
import { CalendarFormComponent } from './Component/Calendar/CalendarForm/CalendarForm.component';
import { CalendarListComponent } from './Component/Calendar/CalendarList/CalendarList.component';
import { MoneyAddComponent } from './Component/Money/MoneyAdd/MoneyAdd.component';
import { MoneyEditComponent } from './Component/Money/MoneyEdit/MoneyEdit.component';
import { MoneyListComponent } from './Component/Money/MoneyList/MoneyList.component';
import { LetterRequestCustomerScheduleCancelComponent } from './Component/Letter/LetterRequestCustomerScheduleCancel/LetterRequestCustomerScheduleCancel.component';
import { DeviceBehfaRepairComponent } from './Component/DeviceBehfa/DeviceBehfaRepair/DeviceBehfaRepair.component';
import { DeviceBehfaRepairFormComponent } from './Component/DeviceBehfa/DeviceBehfaRepairForm/DeviceBehfaRepairForm.component';
import { HelpListComponent } from './Component/Help/HelpList/HelpList.component';
import { HelpFormComponent } from './Component/Help/HelpForm/HelpForm.component';
import { HelpViewComponent } from './Component/Help/HelpView/HelpView.component';
import { LetterRequestCustomerInboxComponent } from './Component/Letter/LetterRequestCustomerInbox/LetterRequestCustomerInbox.component';
import { LetterRequestCustomerDeviceBehfaComponent } from './Component/Letter/LetterRequestCustomerDeviceBehfa/LetterRequestCustomerDeviceBehfa.component';
import { TariffHistoryComponent } from './Component/Tariff/TariffHistory/TariffHistory.component';
import { DeviceBehfaActiveListComponent } from './Component/DeviceBehfa/DeviceBehfaActiveList/DeviceBehfaActiveList.component';
import { KartableInboxComponent } from './Component/Kartable/KartableInbox/KartableInbox.component';
import { PersonEdit1Component } from './Component/Person/PersonEdit1/PersonEdit1.component';
import { PersonList1Component } from './Component/Person/PersonList1/PersonList1.component';
import { LetterRequestCustomerFormCustomerComponent } from './Component/Letter/LetterRequestCustomerFormCustomer/LetterRequestCustomerFormCustomer.component';
import { LetterRequestCustomerScheduleCustomerComponent } from './Component/Letter/LetterRequestCustomerScheduleCustomer/LetterRequestCustomerScheduleCustomer.component';
import { UserhistoryComponent } from './Component/User/Userhistory/Userhistory.component';
import { LetterRequestCustomerTreeHistoryComponent } from './Component/Letter/LetterRequestCustomerTreeHistory/LetterRequestCustomerTreeHistory.component';
import { LetterRequestCustomerMissionActivityComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionActivity/LetterRequestCustomerMissionActivity.component';
import { LetterRequestCustomerMissionActivityListComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionActivityList/LetterRequestCustomerMissionActivityList.component';
import { LetterRequestCustomerMissionActivityDeviceComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionActivityDevice/LetterRequestCustomerMissionActivityDevice.component';
import { LetterRequestCustomerMissionActivityFormComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionActivityForm/LetterRequestCustomerMissionActivityForm.component';
import { LetterRequestCustomerReviewComponent } from './Component/Letter/LetterRequestCustomerReviewFoorm/LetterRequestCustomerReview/LetterRequestCustomerReview.component';
import { AlertFormComponent } from './Component/Alert/AlertForm/AlertForm.component';
import { AlertListComponent } from './Component/Alert/AlertList/AlertList.component';
import { LetterRequestCustomerScheduleSentenceComponent } from './Component/Letter/LetterRequestCustomerScheduleSentence/LetterRequestCustomerScheduleSentence.component';
import { CutomerKarshnasComponent } from './Component/Cutomer/CutomerKarshnas/CutomerKarshnas.component';
import { LetterRequestCustomerScheduleFormComponent } from './Component/Letter/LetterRequestCustomerScheduleForm/LetterRequestCustomerScheduleForm.component';
import { CustomerEditUserComponent } from './Component/Cutomer/CustomerEditUser/CustomerEditUser.component';
import { CustomerListUserComponent } from './Component/Cutomer/CustomerListUser/CustomerListUser.component';
import { LetterRequestCustomerMissionActivityRelativeComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionActivityRelative/LetterRequestCustomerMissionActivityRelative.component';
import { CalibrationDeliveryFormComponent } from './Component/CalibrationDelivery/CalibrationDeliveryForm/CalibrationDeliveryForm.component';
import { CalibrationDeliveryListComponent } from './Component/CalibrationDelivery/CalibrationDeliveryList/CalibrationDeliveryList.component';
import { CalibrationDeliveryViewComponent } from './Component/CalibrationDelivery/CalibrationDeliveryView/CalibrationDeliveryView.component';
import { ColleagueDownloadComponent } from './Component/Colleague/ColleagueDownload/ColleagueDownload.component';
import { ColleagueListComponent } from './Component/Colleague/ColleagueList/ColleagueList.component';
import { DataEntity02Component } from './Component/DataEntity/DataEntity02/DataEntity02.component';
import { QUANTITYControllerComponent } from './Component/QUANTITY/QUANTITYController/QUANTITYController.component';
import { CertificateFormListComponent } from './Component/CertificateForm/CertificateFormList/CertificateFormList.component';
import { CertificateFormFloatPointComponent } from './Component/CertificateForm/CertificateFormFloatPoint/CertificateFormFloatPoint.component';
import { FundsListComponent } from './Component/Funds/FundsList/FundsList.component';
import { FundsFormComponent } from './Component/Funds/FundsForm/FundsForm.component';
import { FundsLetterFormComponent } from './Component/Funds/FundsLetterForm/FundsLetterForm.component';
import { FundsLetterListComponent } from './Component/Funds/FundsLetterList/FundsLetterList.component';
import { FundsUserComponent } from './Component/Funds/FundsUser/FundsUser.component';
import { FundsReviewComponent } from './Component/Funds/FundsReview/FundsReview.component';
import { LabExitReviewComponent } from './Component/Lab/LabExitReview/LabExitReview.component';
import { CabinetFormComponent } from './Component/Cabinet/CabinetForm/CabinetForm.component';
import { CabinetListComponent } from './Component/Cabinet/CabinetList/CabinetList.component';
import { ExpertCalibrationOptionComponent } from './Component/ExpertCalibration/ExpertCalibrationOption/ExpertCalibrationOption.component';
import { FundsTitleFormComponent } from './Component/Funds/FundsTitleForm/FundsTitleForm.component';
import { FundsTitleListComponent } from './Component/Funds/FundsTitleList/FundsTitleList.component';
import { CabinetViewComponent } from './Component/Cabinet/CabinetView/CabinetView.component';
import { CalibrationEvaluateFormComponent } from './Component/Calibration/CalibrationEvaluate/CalibrationEvaluateForm/CalibrationEvaluateForm.component';
import { CalibrationEvaluateListComponent } from './Component/Calibration/CalibrationEvaluate/CalibrationEvaluateList/CalibrationEvaluateList.component';
import { CalibrationEvaluateLetterFormComponent } from './Component/Calibration/CalibrationEvaluate/CalibrationEvaluateLetterForm/CalibrationEvaluateLetterForm.component';
import { PMItemFormComponent } from './Component/PM/PMItemForm/PMItemForm.component';
import { PMItemListComponent } from './Component/PM/PMItemList/PMItemList.component';
import { PMProgramFormComponent } from './Component/PM/PMProgramForm/PMProgramForm.component';
import { PMProgramListComponent } from './Component/PM/PMProgramList/PMProgramList.component';
import { PMDurationFormComponent } from './Component/PM/PMDurationForm/PMDurationForm.component';
import { PMDurationListComponent } from './Component/PM/PMDurationList/PMDurationList.component';
import { PMServiceFormComponent } from './Component/PM/PMServiceForm/PMServiceForm.component';
import { PMServiceListComponent } from './Component/PM/PMServiceList/PMServiceList.component';
import { Filter2Pipe } from './Pipe/filter2.pipe';
import { PMSubmitFormComponent } from './Component/PM/PMSubmitForm/PMSubmitForm.component';
import { PMSubmitListComponent } from './Component/PM/PMSubmitList/PMSubmitList.component';
import { PMServiceHistoryComponent } from './Component/PM/PMServiceHistory/PMServiceHistory.component';
import { UserUrlComponent } from './Component/User/UserUrl/UserUrl.component';
import { DataEntityEnvironmentComponent } from './Component/DataEntity/DataEntityEnvironment/DataEntityEnvironment.component';
import { LetterRequestCustomerScheduleDeviceBehfaComponent } from './Component/Letter/LetterRequestCustomerScheduleDeviceBehfa/LetterRequestCustomerScheduleDeviceBehfa.component';
import { SMSHistoryComponent } from './Component/SMS/SMSHistory/SMSHistory.component';
import { CalibrationDeviceBehfaComponent } from './Component/Calibration/CalibrationDeviceBehfa/CalibrationDeviceBehfa.component';
import { DataEntity02_01Component } from './Component/DataEntity/DataEntity02_01/DataEntity02_01.component';
import { KartableControllerComponent } from './Component/Kartable/KartableController/KartableController.component';
import { CalibrationInPositionCertificateComponent } from './Component/Calibration/CalibrationInPosition/CalibrationInPositionCertificate/CalibrationInPositionCertificate.component';
import { DataEntity03Component } from './Component/DataEntity/DataEntity03/DataEntity03.component';
import { FundsSettleComponent } from './Component/Funds/FundsSettle/FundsSettle.component';
import { FundsWithdrawComponent } from './Component/Funds/FundsWithdraw/FundsWithdraw.component';
import { LetterRequestCustomerMissionFileComponent } from './Component/Letter/LetterRequestCustomerMission/LetterRequestCustomerMissionFile/LetterRequestCustomerMissionFile.component';
import { Protocol17025CatComponent } from './Component/Protocol17025/Protocol17025Cat/Protocol17025Cat.component';
import { Protocol17025Cat_CoComponent } from './Component/Protocol17025/Protocol17025Cat_Co/Protocol17025Cat_Co.component';
import { Protocol17025ChartComponent } from './Component/Protocol17025/Protocol17025Chart/Protocol17025Chart.component';
import { Protocol17025Chart_CoComponent } from './Component/Protocol17025/Protocol17025Chart_Co/Protocol17025Chart_Co.component';
import { Protocol17025ChartFileComponent } from './Component/Protocol17025/Protocol17025ChartFile/Protocol17025ChartFile.component';
import { Protocol17025Cat_Co_CheckComponent } from './Component/Protocol17025/Protocol17025Cat_Co_Check/Protocol17025Cat_Co_Check.component';
import { Protocol17025Cat_CheckComponent } from './Component/Protocol17025/Protocol17025Cat_Check/Protocol17025Cat_Check.component';
import { DataEntity03_01Component } from './Component/DataEntity/DataEntity03_01/DataEntity03_01.component';
import { LetterRequestCustomerReviewFormComponent } from './Component/Letter/LetterRequestCustomerReviewFoorm/LetterRequestCustomerReviewForm/LetterRequestCustomerReviewForm.component';
import { LetterRequestCustomerReviewFormListComponent } from './Component/Letter/LetterRequestCustomerReviewFoorm/LetterRequestCustomerReviewFormList/LetterRequestCustomerReviewFormList.component';
import { LetterRequestCustomerReviewAnswerComponent } from './Component/Letter/LetterRequestCustomerReviewFoorm/LetterRequestCustomerReviewAnswer/LetterRequestCustomerReviewAnswer.component';
import { Protocol17025ViewComponent } from './Component/Protocol17025/Protocol17025View/Protocol17025View.component';
import { KartableControllerReviewComponent } from './Component/Kartable/KartableControllerReview/KartableControllerReview.component';
import { AlertUserListComponent } from './Component/Alert/AlertUserList/AlertUserList.component';
import { KartableDevicePointComponent } from './Component/Kartable/KartableDevicePoint/KartableDevicePoint.component';
import { DataEntity03_02Component } from './Component/DataEntity/DataEntity03_02/DataEntity03_02.component';
import { DeviceInLetterComponent } from './Component/Device/DeviceInLetter/DeviceInLetter.component';
import { ScheduleFormComponent } from './Component/Schedule/ScheduleForm/ScheduleForm.component';
import { SuggestTitleAddComponent } from './Component/Suggest/SuggestTitle/SuggestTitleAdd/SuggestTitleAdd.component';
import { SuggestTitleEditComponent } from './Component/Suggest/SuggestTitle/SuggestTitleEdit/SuggestTitleEdit.component';
import { SuggestTitleListComponent } from './Component/Suggest/SuggestTitle/SuggestTitleList/SuggestTitleList.component';
import { SuggestListComponent } from './Component/Suggest/SuggestMain/SuggestList/SuggestList.component';
import { SuggestFormComponent } from './Component/Suggest/SuggestMain/SuggestForm/SuggestForm.component';
import { KartableDevicePoint2Component } from './Component/Kartable/KartableDevicePoint2/KartableDevicePoint2.component';
import { DeviceConditionFormComponent } from './Component/DeviceCondition/DeviceConditionForm/DeviceConditionForm.component';
import { DeviceConditionListComponent } from './Component/DeviceCondition/DeviceConditionList/DeviceConditionList.component';
import { KartableCertificateComponent } from './Component/Kartable/KartableCertificate/KartableCertificate.component';
import { Chart_CoComponent } from './Component/Chart/Chart_Co/Chart_Co.component';
import { ChartComponent } from './Component/Chart/Chart/Chart.component';
import { CutomerTitleComponent } from './Component/Cutomer/CutomerTitle/CutomerTitle.component';
import { FlowchartMainComponent } from './Component/Flowchart/FlowchartMain/FlowchartMain.component';
import { FlowchartWorkflowComponent } from './Component/Flowchart/FlowchartWorkflow/FlowchartWorkflow.component';
import { PersonOffDayAddComponent } from './Component/Person/PersonOffDay/PersonOffDayAdd/PersonOffDayAdd.component';
import { PersonOffDayListComponent } from './Component/Person/PersonOffDay/PersonOffDayList/PersonOffDayList.component';
import { PersonOffDayViewComponent } from './Component/Person/PersonOffDay/PersonOffDayView/PersonOffDayView.component';
import { FlowchartFormComponent } from './Component/Flowchart/FlowchartForm/FlowchartForm.component';
import { FlowchartInboxComponent } from './Component/Flowchart/FlowchartInbox/FlowchartInbox.component';
import { FlowchartHistoryComponent } from './Component/Flowchart/FlowchartHistory/FlowchartHistory.component';
import { FlowchartArchiveComponent } from './Component/Flowchart/FlowchartArchive/FlowchartArchive.component';
import { SuggestReportComponent } from './Component/Suggest/SuggestMain/SuggestReport/SuggestReport.component';
import { DataEntity04Component } from './Component/DataEntity/DataEntity04/DataEntity04.component';
import { Chart_CheckComponent } from './Component/Chart/Chart_Check/Chart_Check.component';
import { Chart_Check_CoComponent } from './Component/Chart/Chart_Check_Co/Chart_Check_Co.component';
import { CutomerViewComponent } from './Component/Cutomer/CutomerView/CutomerView.component';
import { DataEntity05Component } from './Component/DataEntity/DataEntity05/DataEntity05.component';
import { CutomerKarshnasFormComponent } from './Component/Cutomer/CutomerKarshnasForm/CutomerKarshnasForm.component';
import { AddressLetterCertificateComponent } from './Component/AddressTitle/AddressLetterCertificate/AddressLetterCertificate.component';
import { DataEntity06Component } from './Component/DataEntity/DataEntity06/DataEntity06.component';
import { DataEntity07Component } from './Component/DataEntity/DataEntity07/DataEntity07.component';
import { ProductGroupAddComponent } from './Component/ProductGroup/ProductGroupAdd/ProductGroupAdd.component';
import { ProductGroupEditComponent } from './Component/ProductGroup/ProductGroupEdit/ProductGroupEdit.component';
import { ProductGroupListComponent } from './Component/ProductGroup/ProductGroupList/ProductGroupList.component';
import { ProductAddComponent } from './Component/Product/ProductAdd/ProductAdd.component';
import { ProductEditComponent } from './Component/Product/ProductEdit/ProductEdit.component';
import { ProductListComponent } from './Component/Product/ProductList/ProductList.component';
import { ProductRequestAddComponent } from './Component/ProductRequest/ProductRequestAdd/ProductRequestAdd.component';
import { ProductRequestListComponent } from './Component/ProductRequest/ProductRequestList/ProductRequestList.component';
import { ProductRequestViewComponent } from './Component/ProductRequest/ProductRequestView/ProductRequestView.component';
import { ProductRequestReviewFormComponent } from './Component/ProductRequest/ProductRequestReviewForm/ProductRequestReviewForm.component';
import { PersonOffTimeAddComponent } from './Component/Person/PersonOffTime/PersonOffTimeAdd/PersonOffTimeAdd.component';
import { PersonOffTimeListComponent } from './Component/Person/PersonOffTime/PersonOffTimeList/PersonOffTimeList.component';
import { PersonOffTimeViewComponent } from './Component/Person/PersonOffTime/PersonOffTimeView/PersonOffTimeView.component';
import { DataEntity08Component } from './Component/DataEntity/DataEntity08/DataEntity08.component';
import { DataEntity09Component } from './Component/DataEntity/DataEntity09/DataEntity09.component';
import { DataEntity10Component } from './Component/DataEntity/DataEntity10/DataEntity10.component';
import { DeviceMappingComponent } from './Component/Device/DeviceMapping/DeviceMapping.component';
import { DataEntityLabAddressComponent } from './Component/DataEntity/DataEntityLabAddress/DataEntityLabAddress.component';
import { DataEntityLinearityComponent } from './Component/DataEntity/DataEntityLinearity/DataEntityLinearity.component';
import { CertificateNoteAddComponent } from './Component/CertificateNote/CertificateNoteAdd/CertificateNoteAdd.component';
import { CertificateNoteListComponent } from './Component/CertificateNote/CertificateNoteList/CertificateNoteList.component';
import { DataEntityCertificateNoteComponent } from './Component/DataEntity/DataEntityCertificateNote/DataEntityCertificateNote.component';
import { UserErrorComponent } from './Component/User/UserError/UserError.component';
import { DeviceBehfaRefComponent } from './Component/DeviceBehfa/DeviceBehfaRef/DeviceBehfaRef.component';
import { DeviceBehfaRefViewComponent } from './Component/DeviceBehfa/DeviceBehfaRefView/DeviceBehfaRefView.component';
import { DataEntityDeviceInfoComponent } from './Component/DataEntity/DataEntityDeviceInfo/DataEntityDeviceInfo.component';
import { DataEntityDeviceInfoViewComponent } from './Component/DataEntity/DataEntityDeviceInfoView/DataEntityDeviceInfoView.component';
import { CalibrationRequestToExitComponent } from './Component/Calibration/CalibrationRequestToExit/CalibrationRequestToExit.component';
import { CalibrationInPositionRequestStatusComponent } from './Component/Calibration/CalibrationInPosition/CalibrationInPositionRequestStatus/CalibrationInPositionRequestStatus.component';
import { DataEntity11Component } from './Component/DataEntity/DataEntity11/DataEntity11.component';
import { RoleFormComponent } from './Component/Role/RoleForm/RoleForm.component';
import { RoleListComponent } from './Component/Role/RoleList/RoleList.component';
import { RoleUserComponent } from './Component/Role/RoleUser/RoleUser.component';
import { KartableCustomerReportComponent } from './Component/Kartable/KartableCustomerReport/KartableCustomerReport.component';
import { ScheduleLetterFormComponent } from './Component/Schedule/ScheduleLetter/ScheduleLetterForm/ScheduleLetterForm.component';
import { ScheduleLetterListComponent } from './Component/Schedule/ScheduleLetter/ScheduleLetterList/ScheduleLetterList.component';
import { ScheduleLetterModirListComponent } from './Component/Schedule/ScheduleLetterModir/ScheduleLetterModirList/ScheduleLetterModirList.component';
import { ScheduleLetterModirViewComponent } from './Component/Schedule/ScheduleLetterModir/ScheduleLetterModirView/ScheduleLetterModirView.component';
import { DataEntity11_01Component } from './Component/DataEntity/DataEntity11_01/DataEntity11_01.component';
import { DataEntityVolumeFormComponent } from './Component/DataEntity/DataEntityVolumeForm/DataEntityVolumeForm.component';
import { DataEntityThermometerFormComponent } from './Component/DataEntity/DataEntityThermometerForm/DataEntityThermometerForm.component';
import { DataEntityVolumeCertificateResultComponent } from './Component/DataEntity/DataEntityVolumeForm/DataEntityVolumeCertificateResult.component';
import { DataEntityVolumeCertificateFormulaComponent } from './Component/DataEntity/DataEntityVolumeForm/DataEntityVolumeCertificateFormula.component';
import { DataEntityMassFormComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassForm.component';
import { DataEntityMassMeasurementComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassMeasurement.component';
import { DataEntityMassWeightInputComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassWeightInput.component';
import { DataEntityMassCertificateResultComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassCertificateResult.component';
import { DataEntityMassNModelsComponent } from './Component/DataEntity/DataEntityMassForm/DataEntityMassNModels.component';
import { TariffFloorComponent } from './Component/Tariff/TariffFloor/TariffFloor.component';
import { PersonOptionComponent } from './Component/Person/PersonOption/PersonOption.component';
import { AzmoonMaharatMainFormComponent } from './Component/AzmoonMaharat/AzmoonMaharatMain/AzmoonMaharatMainForm/AzmoonMaharatMainForm.component';
import { AzmoonMaharatMainListComponent } from './Component/AzmoonMaharat/AzmoonMaharatMain/AzmoonMaharatMainList/AzmoonMaharatMainList.component';
import { AzmoonMaharatDetailFormComponent } from './Component/AzmoonMaharat/AzmoonMaharatDetail/AzmoonMaharatDetailForm/AzmoonMaharatDetailForm.component';
import { AzmoonMaharatDetailListComponent } from './Component/AzmoonMaharat/AzmoonMaharatDetail/AzmoonMaharatDetailList/AzmoonMaharatDetailList.component';
import { AzmoonMaharatRequestCalenderComponent } from './Component/AzmoonMaharat/AzmoonMaharatRequest/AzmoonMaharatRequestCalender/AzmoonMaharatRequestCalender.component';
import { AzmoonMaharatMainSignInListComponent } from './Component/AzmoonMaharat/AzmoonMaharatMainSignIn/AzmoonMaharatMainSignInList/AzmoonMaharatMainSignInList.component';
import { AzmoonMaharatMainSignInDetailComponent } from './Component/AzmoonMaharat/AzmoonMaharatMainSignIn/AzmoonMaharatMainSignInDetail/AzmoonMaharatMainSignInDetail.component';
import { AzmoonMaharatRequestListComponent } from './Component/AzmoonMaharat/AzmoonMaharatRequest/AzmoonMaharatRequestList/AzmoonMaharatRequestList.component';
import { AzmoonMaharatMainConfirmComponent } from './Component/AzmoonMaharat/AzmoonMaharatMainSignIn/AzmoonMaharatMainConfirm/AzmoonMaharatMainConfirm.component';
import { DeviceBehfaFilterGroupFormComponent } from './Component/DeviceBehfaFilterGroup/DeviceBehfaFilterGroupForm/DeviceBehfaFilterGroupForm.component';
import { DeviceBehfaFilterGroupListComponent } from './Component/DeviceBehfaFilterGroup/DeviceBehfaFilterGroupList/DeviceBehfaFilterGroupList.component';
import { DeviceBehfaFilterGroupDetailComponent } from './Component/DeviceBehfaFilterGroup/DeviceBehfaFilterGroupDetail/DeviceBehfaFilterGroupDetail.component';
import { LetterrequestcustomerRelativeFormComponent } from './Component/LetterrequestcustomerRelative/LetterrequestcustomerRelativeForm/LetterrequestcustomerRelativeForm.component';
import { LetterrequestcustomerRelativeListComponent } from './Component/LetterrequestcustomerRelative/LetterrequestcustomerRelativeList/LetterrequestcustomerRelativeList.component';
import { LetterrequestcustomerFactorFormComponent } from './Component/LetterrequestcustomerFactor/LetterrequestcustomerFactorForm/LetterrequestcustomerFactorForm.component';
import { LetterrequestcustomerFactorListComponent } from './Component/LetterrequestcustomerFactor/LetterrequestcustomerFactorList/LetterrequestcustomerFactorList.component';
import { LetterrequestcustomerIgnoreComponent } from './Component/Letter/LetterrequestcustomerIgnore/LetterrequestcustomerIgnore.component';
import { SalaryBaseFormComponent } from './Component/Salary/SalaryBaseForm/SalaryBaseForm.component';
import { SalaryListComponent } from './Component/Salary/SalaryList/SalaryList.component';
import { SalaryPersonFormComponent } from './Component/Salary/SalaryPersonForm/SalaryPersonForm.component';
import { SalaryEzafeKarComponent } from './Component/Salary/SalaryEzafeKar/SalaryEzafeKar.component';
import { DeviceBehfaPerformanceComponent } from './Component/DeviceBehfa/DeviceBehfaPerformance/DeviceBehfaPerformance.component';
import { SalaryMonthListComponent } from './Component/Salary/SalaryMonthList/SalaryMonthList.component';
import { SalaryFishComponent } from './Component/Salary/SalaryFish/SalaryFish.component';
import { SalaryDayListComponent } from './Component/Salary/SalaryDayList/SalaryDayList.component';
import { LetterRequestCustomerReportComponent } from './Component/Letter/LetterRequestCustomerReport/LetterRequestCustomerReport.component';
import { SubjectLetterOptionComponent } from './Component/SubjectLetter/SubjectLetterOption/SubjectLetterOption.component';
import { SalarySanavatListComponent } from './Component/Salary/SalarySanavatList/SalarySanavatList.component';
import { KartableBarchasbComponent } from './Component/Kartable/KartableBarchasb/KartableBarchasb.component';


import { PM_V2_TemplateListComponent } from './Component/PM_V2/PM_V2_TemplateList/PM_V2_TemplateList.component';
import { PM_V2_TemplateAddComponent } from './Component/PM_V2/PM_V2_TemplateAdd/PM_V2_TemplateAdd.component';
import { PM_V2_TemplateEditComponent } from './Component/PM_V2/PM_V2_TemplateEdit/PM_V2_TemplateEdit.component';
import { PM_V2_AssignmentListComponent } from './Component/PM_V2/PM_V2_AssignmentList/PM_V2_AssignmentList.component';
import { PM_V2_AssignmentAddComponent } from './Component/PM_V2/PM_V2_AssignmentAdd/PM_V2_AssignmentAdd.component';
import { PM_V2_AssignmentDetailComponent } from './Component/PM_V2/PM_V2_AssignmentDetail/PM_V2_AssignmentDetail.component';
import { PM_V2_DueListComponent } from './Component/PM_V2/PM_V2_DueList/PM_V2_DueList.component';
import { PM_V2_DueEquipmentDetailComponent } from './Component/PM_V2/PM_V2_DueEquipmentDetail/PM_V2_DueEquipmentDetail.component';
import { PM_V2_ExecutionAddComponent } from './Component/PM_V2/PM_V2_ExecutionAdd/PM_V2_ExecutionAdd.component';
import { PM_V2_ExecutionHistoryComponent } from './Component/PM_V2/PM_V2_ExecutionHistory/PM_V2_ExecutionHistory.component';
import { ICTemplateListComponent } from './Component/IC/ICTemplateList/ICTemplateList.component';
import { ICTemplateAddComponent } from './Component/IC/ICTemplateAdd/ICTemplateAdd.component';
import { ICTemplateEditComponent } from './Component/IC/ICTemplateEdit/ICTemplateEdit.component';
import { ICAssignmentListComponent } from './Component/IC/ICAssignmentList/ICAssignmentList.component';
import { ICAssignmentAddComponent } from './Component/IC/ICAssignmentAdd/ICAssignmentAdd.component';
import { ICAssignmentDetailComponent } from './Component/IC/ICAssignmentDetail/ICAssignmentDetail.component';
import { ICDueListComponent } from './Component/IC/ICDueList/ICDueList.component';
import { ICCalculationDetailsComponent } from './Component/IC/ICCalculationDetails/ICCalculationDetails.component';
import { ICExecutionAddComponent } from './Component/IC/ICExecutionAdd/ICExecutionAdd.component';
import { ICExecutionHistoryComponent } from './Component/IC/ICExecutionHistory/ICExecutionHistory.component';
import { ICDashboardComponent } from './Component/IC/ICDashboard/ICDashboard.component';
import { ICTrendComponent } from './Component/IC/ICTrend/ICTrend.component';
import { ICEquipmentTabComponent } from './Component/IC/ICEquipmentTab/ICEquipmentTab.component';
import { OrderByPipe } from './Pipe/order-by.pipe';

@NgModule({
  declarations: [
    PersonLeaveLimitSettingsComponent,
    PersianDatepickerInputCompatDirective,
    PM_V2_TemplateListComponent,
    PM_V2_TemplateAddComponent,
    PM_V2_TemplateEditComponent,
    PM_V2_AssignmentListComponent,
    PM_V2_AssignmentAddComponent,
    PM_V2_AssignmentDetailComponent,
    PM_V2_DueListComponent,
    PM_V2_DueEquipmentDetailComponent,
    PM_V2_ExecutionAddComponent,
    PM_V2_ExecutionHistoryComponent,
    ICTemplateListComponent,
    ICTemplateAddComponent,
    ICTemplateEditComponent,
    ICAssignmentListComponent,
    ICAssignmentAddComponent,
    ICAssignmentDetailComponent,
    ICDueListComponent,
    ICCalculationDetailsComponent,
    ICExecutionAddComponent,
    ICExecutionHistoryComponent,
    ICDashboardComponent,
    ICTrendComponent,
    ICEquipmentTabComponent,
    FilterPipe,
    Filter2Pipe,

    AppComponent,
    NavComponent,
    DashboardComponent,
    LockscreenComponent,

    FeildActiviryAddComponent,
    FeildActivityListComponent,
    FieldActivityEditComponent,

    CustomerAddComponent,
    CustomerEditUserComponent,
    CustomerListUserComponent,
    CustomerEditComponent,
    CustomerListComponent,
    CutomeruserformComponent,
    CutomerInfoComponent,
    CutomerViewComponent,
    CutomerCommentComponent,
    CutomerCommentViewComponent,
    CutomerCommentCheckComponent,
    CutomerKarshnasComponent,
    CutomerKarshnasFormComponent,
    CutomerTitleComponent,

    DeviceListComponent,
    DeviceEditComponent,
    DeviceAddComponent,
    DeviceInLetterComponent,
    DeviceMappingComponent,

    ContractorListComponent,
    ContractorAddComponent,
    ContractorEditComponent,
    ContractorCustomerComponent,

    UserAddComponent,
    UserEditComponent,
    UserListComponent,
    UserTreeviewComponent,
    UserhistoryComponent,
    UserUrlComponent,
    UserErrorComponent,

    FlowchartMainComponent,
    FlowchartWorkflowComponent,
    FlowchartFormComponent,
    FlowchartInboxComponent,
    FlowchartHistoryComponent,
    FlowchartArchiveComponent,


    PersonOffDayAddComponent,
    PersonOffDayListComponent,
    PersonOffDayViewComponent,

    ExpirationListComponent,
    ExpirationAddComponent,
    ExpirationEditComponent,

    SematListComponent,
    SematAddComponent,
    SematEditComponent,

    PersonListComponent,
    PersonList1Component,
    PersonAddComponent,
    PersonEditComponent,
    PersonEdit1Component,

    DocumentTitleListComponent,
    DocumentTitleAddComponent,
    DocumentTitleEditComponent,

    DocumentGroupListComponent,
    DocumentGroupAddComponent,
    DocumentGroupEditComponent,

    TariffListComponent,
    TariffAddComponent,
    TariffEditComponent,
    TariffHistoryComponent,
    TariffFloorComponent,

    HelpListComponent,
    HelpFormComponent,
    HelpViewComponent,

    SkillListComponent,
    SkillAddComponent,
    SkillEditComponent,

    SuggestTitleAddComponent,
    SuggestTitleEditComponent,
    SuggestTitleListComponent,

    SuggestReportComponent,
    SuggestListComponent,
    SuggestFormComponent,

    UnitListComponent,
    UnitAddComponent,
    UnitEditComponent,

    DefinitionscertificateListComponent,
    DefinitionscertificateAddComponent,

    DevicepersianAddComponent,
    DevicepersianEditComponent,
    DevicepersianListComponent,

    DeviceBehfaListComponent,
    DeviceBehfaAddComponent,
    DeviceBehfaDownloadFormComponent,
    DeviceBehfaUploadFormComponent,
    DeviceBehfaEditComponent,
    DeviceBehfaDownloadUploadComponent,
    DeviceBehfaGozareshKarkardComponent,
    DeviceBehfaConfirmUploadedComponent,
    DeviceBehfaChangeOperationComponent,
    DeviceBehfaRepairComponent,
    DeviceBehfaRepairFormComponent,
    DeviceBehfaActiveListComponent,
    DeviceBehfaPerformanceComponent,

    ProductGroupAddComponent,
    ProductGroupEditComponent,
    ProductGroupListComponent,

    ProductAddComponent,
    ProductEditComponent,
    ProductListComponent,

    ProductRequestAddComponent,
    ProductRequestListComponent,
    ProductRequestViewComponent,
    ProductRequestReviewFormComponent,

    PersonOffTimeAddComponent,
    PersonOffTimeListComponent,
    PersonOffTimeViewComponent,
    PersonOptionComponent,

    TextletterListComponent,
    TextletterAddComponent,
    TextletterEditComponent,

    AddressTitleListComponent,
    AddressTitleAddComponent,
    AddressTitleEditComponent,

    SubjectLetterListComponent,
    SubjectLetterAddComponent,
    SubjectLetterEditComponent,

    SMSTextListComponent,
    SMSTextAddComponent,
    SMSTextEditComponent,

    MailMessageListComponent,
    MailMessageAddComponent,
    MailMessageEditComponent,

    DorehAmoozeshiListComponent,
    DorehAmoozeshiAddComponent,
    DorehAmoozeshiEditComponent,

    SarFaslAmozeshiListComponent,
    SarFaslAmozeshiAddComponent,
    SarFaslAmozeshiEditComponent,

    ExpertCalibrationAddComponent,
    ExpertCalibrationEditComponent,
    ExpertCalibrationListComponent,
    ExpertCalibrationOptionComponent,

    CalibrationInPositionFormComponent,
    CalibrationInPositionListComponent,
    CalibrationInPositionCertificateComponent,

    CalibrationReceptionFormComponent,
    CalibrationReceptionListComponent,

    CalibrationEvaluateFormComponent,
    CalibrationEvaluateListComponent,
    CalibrationEvaluateLetterFormComponent,

    CalibrationDeviceBehfaComponent,
    CalibrationRequestToExitComponent,
    CalibrationInPositionRequestStatusComponent,

    CertificateFormComponent,
    CertificateAsliComponent,
    CertificateListComponent,
    CertifivateDeliveryListComponent,
    CertifivateDeliveryFormComponent,

    LetterRequestCustomerComponent,
    LetterRequestCustomerFormComponent,
    LetterRequestCustomerDraftFormComponent,
    LetterRequestCustomerHistoryComponent,
    LetterRequestCustomerPeyvastComponent,
    LetterRequestCustomerPreOrderComponent,
    LetterRequestCustomerScheduleCancelComponent,
    LetterRequestCustomerInboxComponent,
    LetterRequestCustomerDeviceBehfaComponent,
    LetterRequestCustomerFormCustomerComponent,
    LetterRequestCustomerScheduleCustomerComponent,
    LetterRequestCustomerTreeHistoryComponent,
    LetterRequestCustomerMissionActivityComponent,
    LetterRequestCustomerMissionActivityListComponent,
    LetterRequestCustomerMissionActivityDeviceComponent,
    LetterRequestCustomerMissionActivityFormComponent,
    LetterRequestCustomerReviewComponent,
    LetterRequestCustomerScheduleSentenceComponent,
    LetterRequestCustomerScheduleFormComponent,
    LetterRequestCustomerMissionActivityRelativeComponent,
    LetterRequestCustomerScheduleDeviceBehfaComponent,
    LetterRequestCustomerMissionFileComponent,

    AlertFormComponent,
    AlertListComponent,
    AlertUserListComponent,

    DeviceGroupComponent,
    DeviceGroupTreeviewComponent,

    QUANTITYComponent,
    QUANTITYControllerComponent,

    LabDownloadUploadDeviceComponent,
    LabCalibrationComponent,
    LabCertificateComponent,
    LabDownloadDeviceFormComponent,
    LabUploadDeviceFormComponent,
    LabConfirmCalibrationComponent,
    LabExitReviewComponent,

    CabinetFormComponent,
    CabinetListComponent,
    CabinetViewComponent,

    LetterRequestCustomerPreOrderListComponent,
    LetterRequestCustomerDeviceComponent,
    LetterRequestCustomerDeviceListComponent,
    LetterRequestCustomerCalibrationComponent,
    LetterRequestCustomerCalibrationListComponent,
    LetterRequestCustomerScheduleComponent,
    LetterRequestCustomerReviewFormComponent,
    LetterRequestCustomerReviewFormListComponent,
    LetterRequestCustomerReviewAnswerComponent,
    LetterRequestCustomerReportComponent,

    SubjectLetterOptionComponent,

    RepresentativeAddComponent,
    RepresentativeEditComponent,
    RepresentativeListComponent,

    TicketListComponent,
    TicketFormComponent,
    TicketReplyComponent,
    TicketAdminFormComponent,

    BehfaRoleAddComponent,
    BehfaRoleEditComponent,
    BehfaRoleListComponent,
    BehfaRoleListAdminComponent,

    BehfaListAdminComponent,
    BehfaListComponent,
    DeviceBehfaRefComponent,
    DeviceBehfaRefViewComponent,

    TicketCategoryAddComponent,
    TicketCategoryEditComponent,
    TicketCategoryListComponent,

    MoneyAddComponent,
    MoneyEditComponent,
    MoneyListComponent,

    CalendarFormComponent,
    CalendarListComponent,

    KartableInboxComponent,
    KartableControllerComponent,
    KartableControllerReviewComponent,
    KartableDevicePointComponent,
    KartableDevicePoint2Component,
    KartableCertificateComponent,
    KartableCustomerReportComponent,

    ChartComponent,
    Chart_CoComponent,
    Chart_CheckComponent,
    Chart_Check_CoComponent,

    DataEntity01Component,
    DataEntity02Component,
    DataEntity02_01Component,
    DataEntity03Component,
    DataEntity03_01Component,
    DataEntity03_02Component,
    DataEntity04Component,
    DataEntity05Component,
    DataEntity06Component,
    DataEntity07Component,
    DataEntity08Component,
    DataEntity09Component,
    DataEntity10Component,
    DataEntity11Component,
    DataEntity11_01Component,
    DataEntityVolumeFormComponent,
    DataEntityThermometerFormComponent,
    DataEntityBalanceFormComponent,
    DataEntityVolumeCertificateResultComponent,
    DataEntityVolumeCertificateFormulaComponent,
    DataEntityMassFormComponent,
    DataEntityMassMeasurementComponent,
    DataEntityMassWeightInputComponent,
    DataEntityMassCertificateResultComponent,
    DataEntityMassNModelsComponent,

    DataEntityEnvironmentComponent,
    DataEntityLabAddressComponent,
    DataEntityLinearityComponent,
    DataEntityCertificateNoteComponent,
    DataEntityDeviceInfoComponent,
    DataEntityDeviceInfoViewComponent,
    
    CertificateNoteAddComponent,
    CertificateNoteListComponent,

    LoginComponent,

    CalibrationDeliveryFormComponent,
    CalibrationDeliveryListComponent,
    CalibrationDeliveryViewComponent,


    ColleagueDownloadComponent,
    ColleagueListComponent,

    CertificateFormListComponent,
    CertificateFormFloatPointComponent,

    FundsListComponent,
    FundsFormComponent,
    FundsLetterFormComponent,
    FundsLetterListComponent,
    FundsUserComponent,
    FundsReviewComponent,
    FundsTitleFormComponent,
    FundsTitleListComponent,
    FundsSettleComponent,
    FundsWithdrawComponent,

    PMItemFormComponent,
    PMItemListComponent,
    PMProgramFormComponent,
    PMProgramListComponent,
    PMDurationFormComponent,
    PMDurationListComponent,
    PMServiceFormComponent,
    PMServiceListComponent,
    PMSubmitFormComponent,
    PMSubmitListComponent,
    PMServiceHistoryComponent,

    SMSHistoryComponent,

    DeviceConditionFormComponent,
    DeviceConditionListComponent,

    Protocol17025CatComponent,
    Protocol17025Cat_CoComponent,

    Protocol17025ChartComponent,
    Protocol17025Chart_CoComponent,
    Protocol17025ChartFileComponent,

    Protocol17025ViewComponent,

    Protocol17025Cat_CheckComponent,
    Protocol17025Cat_Co_CheckComponent,

    ScheduleFormComponent,
    ScheduleLetterFormComponent,
    ScheduleLetterListComponent,
    ScheduleLetterModirListComponent,
    ScheduleLetterModirViewComponent,

    AddressLetterCertificateComponent,

    
    LetterrequestcustomerRelativeFormComponent,
    LetterrequestcustomerRelativeListComponent,

    RoleFormComponent,
    RoleListComponent,
    RoleUserComponent,

    AzmoonMaharatMainFormComponent,
    AzmoonMaharatMainListComponent,
    AzmoonMaharatDetailFormComponent,
    AzmoonMaharatDetailListComponent,

    AzmoonMaharatRequestCalenderComponent,

    AzmoonMaharatMainSignInListComponent,
    AzmoonMaharatMainSignInDetailComponent,

    AzmoonMaharatRequestListComponent,
    AzmoonMaharatMainConfirmComponent,

    DeviceBehfaFilterGroupFormComponent,
    DeviceBehfaFilterGroupListComponent,
    DeviceBehfaFilterGroupDetailComponent,

    LetterrequestcustomerFactorFormComponent,
    LetterrequestcustomerFactorListComponent,
    LetterrequestcustomerIgnoreComponent,

    SalaryBaseFormComponent,
    SalaryListComponent,
    SalaryPersonFormComponent,
    SalaryEzafeKarComponent,
    SalaryMonthListComponent,
    SalaryFishComponent,
    SalarySanavatListComponent,

    SalaryDayListComponent,
    KartableBarchasbComponent,
    CalibrationConfirmInvoiceComponent,
    CalibrationConfirmInvoiceFormComponent,
    LetterrequestcustomerFactor2Component,
    LetterrequestcustomerFactor2FormComponent,


    OrderByPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxPaginationModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgPersianDatepickerModule,
    NgChartsModule,
    ModalModule,
    TooltipModule,
    NgxImgZoomModule,
    CKEditorModule
  ],

  providers: [
    BsModalService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
